module.exports = __webpack_public_path__ + "img/a4.afd51e23.png";